import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TaskType } from '../../home/models/taskType';
import { Dashboard } from '../../home/models/dashboard';
import { IDemoWelcomeForm } from '../models/demoWelcomeForm';

@Injectable({
	providedIn: 'root'
})
export class HomeService {
	constructor(private http: HttpClient) {}

	dashboard(): Observable<Dashboard> {
		return this.http.get<Dashboard>('/api/v1/users/demo-dashboard/')
			.pipe(
				catchError(() => of({
					steps: {
						[TaskType.Assortment]: false,
						[TaskType.Equipment]: false,
						[TaskType.Plan]: false,
						[TaskType.ExportPlanogram]: false,
						[TaskType.Planogram]: false,
						[TaskType.ChooseTariff]: false
					},
					assortment_type: 'NONE' as const
				}))
			);
	}

	getDemoAssortmentCategories(): Observable<string[]> {
		return this.http.get<string[]>('/api/v1/users/demo-assortment-categories/');
	}

	setDemoAssortmentCategories(categories: string[]): Observable<void> {
		return this.http.post<void>('/api/v1/users/demo-assortment-categories/', {
			categories: categories
		});
	}
}
